import memoizeOne from 'memoize-one';
import { createSelector } from 'reselect';

import { selectLoanApplication } from './loanApplication.selectors';

const selectSubmissionReadiness = createSelector(
  selectLoanApplication,
  ({ submissionReadiness }) => submissionReadiness,
);

const selectSubmissionReadinessData = createSelector(selectSubmissionReadiness, ({ data }) => data);

export const selectSubmissionReadinessByApplicationId = memoizeOne(applicationId =>
  createSelector(selectSubmissionReadinessData, readiness => readiness?.[applicationId] ?? null),
);
